/**
 * inclusive date-range test shared by the report filter bars.
 *
 * accepts the [start, end] pair emitted by antd's RangePicker. Those entries are
 * moment objects under antd v4, and moment's startOf/endOf mutate in place - so
 * they are cloned before use, otherwise filtering would quietly rewrite the
 * value the picker is still displaying. Comparing on timestamps keeps this
 * working whether the picker hands back moment or dayjs objects.
 *
 * @param {string|Date} value the record's date
 * @param {Array} dateRange [start, end] from the RangePicker, or null when unset
 * @returns {boolean} true when unset or when value falls inside the range
 */
export const isWithinDateRange = (value, dateRange) => {
  if (!dateRange || dateRange.length !== 2 || !dateRange[0] || !dateRange[1])
    return true;

  const time = new Date(value).getTime();
  if (Number.isNaN(time)) return false;

  const start = dateRange[0].clone().startOf("day").valueOf();
  const end = dateRange[1].clone().endOf("day").valueOf();

  return time >= start && time <= end;
};
